var gql = require("@apollo/client").gql;

const TARIFFS_ONE_PROVIDER_CONVERGENT_QUERY = gql`
	query TariffsOneProviderConvergent(
		$operatorUrl: String
		$region_url: String
		$mobileInternet: Int
		$mobileCalls: Int
		$price: Int
	) {
		tariffsOneProviderConvergent(
			operatorUrl: $operatorUrl
			region_url: $region_url
			mobileInternet: $mobileInternet
			mobileCalls: $mobileCalls
			price: $price
		) {
			id
			name
			displayPrice
			cost
			tv {
				channels
				channels_hd
			}
			internet {
				speed_in
			}
			mobile_new {
				sms
				sms_type
				internet
				internet_type
				calls
				calls_type
			}
		}
	}
`;

export default TARIFFS_ONE_PROVIDER_CONVERGENT_QUERY;
